import { render, staticRenderFns } from "./App.vue?vue&type=template&id=28b7cb50&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&lang=less&"
import style1 from "./App.vue?vue&type=style&index=1&id=28b7cb50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b7cb50",
  null
  
)

export default component.exports